import { labeled, boolean, stringRequired, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      allowsPayingOffLoanSooner: boolean(Joi).label(
        labeled(label, 'Allows paying off the loan sooner')
      ),
      allowsAccessToFunds: boolean(Joi).label(labeled(label, 'Allows access to funds')),
      taxPurposes: boolean(Joi).label(
        labeled(label, 'For tax purposes (no tax advice is being given)')
      ),
      other: boolean(Joi).label(labeled(label, 'Other'))
    })
    .orValue('allowsPayingOffLoanSooner', 'allowsAccessToFunds', 'taxPurposes', 'other')
    .label(label)
    .when('.other', {
      is: true,
      then: Joi.object({
        otherComments: stringRequired(Joi, 1, 4096).label(labeled(label, 'Details'))
      })
    });

export default {
  schema
};
